import { AbstractService, ApiResponse } from './core/AbstractService';
import { Category } from './core/types';
import api from './core/api';

class CategoryService extends AbstractService<Category> {
  constructor() {
    super('/categories');
  }

  /**
   * Get parent categories (top-level)
   */
  async getParents(): Promise<ApiResponse<Category[]>> {
    const response = await api.get<ApiResponse<Category[]>>(
      `${this.basePath}/parents`
    );
    return response.data;
  }

  /**
   * Get category tree (hierarchical structure)
   */
  async getTree(): Promise<ApiResponse<Category[]>> {
    const response = await api.get<ApiResponse<Category[]>>(
      `${this.basePath}/tree`
    );
    return response.data;
  }

  /**
   * Get subcategories by parent ID
   */
  async getChildren(parentId: string): Promise<ApiResponse<Category[]>> {
    const response = await api.get<ApiResponse<Category[]>>(
      `${this.basePath}/${parentId}/children`
    );
    return response.data;
  }

  /**
   * Get category by slug
   */
  async getBySlug(slug: string): Promise<ApiResponse<Category>> {
    const response = await api.get<ApiResponse<Category>>(
      `${this.basePath}/slug/${slug}`
    );
    return response.data;
  }
}

export const categoryService = new CategoryService();
export default categoryService;
